import React, { useState, useEffect } from 'react';

import { ContentBox } from '../ContentBox';
import { setVal2Token, getUserInfoCompanyId, getval2Token } from '../../../Login/Auth';
import { WageType_Arr, JobDemand_Arr, RespCustomerPositionInfo, RespCustomerPositionDetail } from '../../../../item/ItemCustomerPosition';
import { getItemsInfo, uuid } from '../../../../item/ItemTools';
import { EnableBadge, Space, CancelButton, SearchButton, SingleLink } from '../../Res/BaseButton';
import { ReqPositionDemandList } from '../../../../item/ItemPositionDemand';
import { api_getPositionDemandList, api_addCustomerPosition } from '../../../../api/apiPositionDemand';
import moment from 'moment';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleInput, SingleSelect } from '../../Res/BaseInput';
import { Pagination } from '../../Res/Pagination';
import Swal from 'sweetalert2';
import { SOCKETIO_URL } from '../../../../config';
import { getWebSocketConnect } from '../../../Login/doitSocket';

export function PositionDemandList({ id, setIsLoading, OnBoard, isEdit, isML }) {
    const [tokenId, setTokenId] = useState("")

    const [companyId] = useState(getUserInfoCompanyId())
    const [positionDemandList, setPositionDemandList] = useState([])

    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)

    const [mReqPositionDemandList, setReqPositionDemandList] = useState({})

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqPositionDemandList = new ReqPositionDemandList({ companyId, start, limit })
            if (url === "") {
                toSearch({ items: mReqPositionDemandList, page: url.page })
            } else {
                mReqPositionDemandList.fromJson(url)
                // console.log(mReqPositionDemandList)
                toSearch({ items: mReqPositionDemandList, page: url.page })
            }
        }
    }, [id])

    // useEffect(() => {
    //     if (positionDemandList.length === 0) {
    //         toSearch({ page: 1 })
    //     }
    // }, [])


    function toSearch({ items, page = 1 }) {
        //console.log("toSearch")
        var start = (page - 1) * limit;
        setPage(page)
        var mReqPositionDemandList = new ReqPositionDemandList({ companyId, start, limit })
        if (items !== undefined)
            mReqPositionDemandList.fromJson(items)
        mReqPositionDemandList.page = page
        setVal2Token("url", mReqPositionDemandList, id)
        setReqPositionDemandList(mReqPositionDemandList)
        getPositionDemandList(mReqPositionDemandList)
    }


    function getPositionDemandList(mReqPositionDemandList) {
        // console.log(mReqPositionDemandList)
        if (setIsLoading !== undefined)
            setIsLoading(true)
        //console.log(mReqCustomerContractList)
        api_getPositionDemandList({
            mReqPositionDemandList,
            success: (obj) => {
                // console.log(obj)
                setPositionDemandList(obj.list)
                setCount(obj.count)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/CustomerPositionAdd/");
    }

    var title = '廠商合約列表'
    var content =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"職缺總數"} count={count} />
                </div>
            </div>
            <Space />
            <PositionDemandListBox list={positionDemandList} srl={setPositionDemandList} count={count} page={page} sp={toSearch} isML={isML} />
        </>
    return (
        <>
            <PositionDemandListSearch action={toSearch} item={mReqPositionDemandList} />
            <ContentBox title={title} content={content} hasDrawer={false} />
            <SystemPromptInput />
        </>
    )
}

function PositionDemandListSearch({ action, item }) {
    const [companyName, setCompanyName] = useState("")
    const [workPlace, setWorkPlace] = useState("")
    const [workAddress, setWorkAddress] = useState("")
    const [contractStatus, setContractStatus] = useState("")
    const [job, setJob] = useState("")
    const [jobType, setJobType] = useState("")
    const [jobDemand, setJobDemand] = useState("")


    useEffect(() => {
        setCompanyName(item.companyName || "")
        setWorkPlace(item.workPlace || "")
        setWorkAddress(item.workAddress || "")
        setContractStatus(item.contractStatus || "")
        setJob(item.job || "")
        setJobType(item.jobType || "")
        setJobDemand(item.jobDemand || "")
    }, [item])

    function toClear() {
        setCompanyName("")
        setWorkPlace("")
        setWorkAddress("")
        setContractStatus("")
        setJob("")
        setJobType("")
        setJobDemand("")
    }

    function toSearch() {
        var mReqResumeList = new ReqPositionDemandList({
            companyName, workPlace, workAddress, contractStatus, job, jobType, jobDemand
        })
        action({ items: mReqResumeList })
    }


    var content =
        <>
            <div className="row">
                <SingleInput title={"以廠商名稱搜尋"} val={companyName} action={setCompanyName} size={4} />
                <SingleInput title={"以工作地址搜尋"} val={workPlace} action={setWorkPlace} size={4} />
                <SingleInput title={"以工作地址搜尋"} val={workAddress} action={setWorkAddress} size={4} />
            </div>
            <div className="hr-line-dashed"></div>
            <div className="row">
                <SingleInput title={"以職缺名稱搜尋"} val={job} action={setJob} size={4} />
                <SingleSelect title={"職缺類型"}
                    val={jobType}
                    attr={[
                        { "val": "", "name": "全部" },
                        { "val": "1", "name": "月薪" },
                        { "val": "2", "name": "時薪" },
                        { "val": "3", "name": "代招" }
                    ]}
                    action={setJobType}
                    size={4}
                />
                <SingleSelect title={"需求量"}
                    val={jobDemand}
                    attr={[
                        { val: "", name: "全部" },
                        { val: 1, name: "大缺" },
                        { val: 2, name: "少量缺，有人再約時間面試" },
                        { val: 3, name: "少量缺，有人送書審" },
                        { val: 4, name: "下週開缺" },
                        { val: 5, name: "下個月初開缺" },
                        { val: 6, name: "下個月中開缺" },
                        { val: 7, name: "下個月底開缺" },
                        { val: 8, name: "額滿" },
                    ]}
                    action={setJobDemand}
                    size={4}
                />
            </div>


            <div className="row m-t-sm m-t-sm">
                <div className="col-sm-4 col-sm-offset-5">
                    <CancelButton name={"清除"} action={toClear} />
                    <SearchButton action={toSearch} />
                </div>
            </div>

        </>
    return (
        <ContentBox hasTitle={false} content={content} hasDrawer={false} />
    )
}

function PositionDemandListBox({ list, srl, count, page, sp, isML }) {
    const [customerContractList, setCustomerContractList] = useState([])
    const [itemList, setItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (list !== undefined && customerContractList !== list) {
            setCustomerContractList(list)
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + list.length)
            setItemList(setTableList(list))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [list, count])

    function setTableList(list) {
        var itemList = []
        for (var i = 0; i < limit; i++) {
            if (list[i] !== undefined) {
                itemList.push(<PositionDemandBox key={list[i].customerPositionId} item={list[i]} isML={isML} />)
            } else {
                itemList.push(<PositionDemandBox key={"resumeId" + i} />)
            }
        }
        return itemList
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (itemList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-1">簽約日期</th>
                                    <th className="text-center sorting col-sm-2">廠商名稱</th>
                                    <th className="text-center sorting col-sm-2">職缺</th>
                                    <th className="text-center sorting col-sm-4">地點/地址</th>
                                    <th className="text-center sorting col-sm-2">需求量</th>
                                    <th className="text-center sorting col-sm-1">共補</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function PositionDemandBox({ item, isML }) {
    const [mItem, setItem] = useState({})
    const [companyId] = useState(getUserInfoCompanyId())
    const [customerContractId, setCustomerContractId] = useState("")
    const [customerPositionId, setCustomerPositionId] = useState("")
    const [signAt, setSignAt] = useState("")
    const [job, setJob] = useState("")
    const [companyName, setCompanyName] = useState("")
    const [shift, setShift] = useState("")
    const [wageType, setWageType] = useState("")
    const [jobDemand, setJobDemand] = useState("")
    const [workPlace, setWorkPlace] = useState("")
    const [workAddress, setWorkAddress] = useState("")
    const [info, setInfo] = useState("")

    const [jobShiftWage, setJobShiftWage] = useState("")


    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            console.log(item)
            setCustomerContractId(item.customerContractId)
            setCustomerPositionId(item.customerPositionId)
            setItem(item)
            setSignAt(moment(item.signAt).format('YYYY-MM-DD'))
            setCompanyName(item.companyName)
            setJob(item.job)
            setShift(item.shift)
            setWageType(item.wageType)
            setJobDemand(item.jobDemand)
            setWorkPlace(item.workPlace)
            setWorkAddress(item.workAddress)
            setInfo(item.info)
            var jobShiftWage = item.job
            jobShiftWage += item !== undefined ? "/" : ""
            jobShiftWage += item.shift
            jobShiftWage += item !== undefined ? "/" : ""
            jobShiftWage += getItemsInfo({ items: WageType_Arr, val: item.wageType })
            // {shift}
            // {item !== undefined ? "/" : <></>}
            // {getItemsInfo({ items: WageType_Arr, val: wageType })}
            setJobShiftWage(jobShiftWage)
        }
    }, [item])

    function chooseDemand() {
        Swal.fire({
            title: '請選擇',
            input: 'select',
            inputOptions: {
                '1': '大缺',
                '2': '少量缺，有人再約時間面試',
                '3': '少量缺，有人送書審',
                '4': '下週開缺',
                '5': '下個月初開缺',
                '6': '下個月中開缺',
                '7': '下個月底開缺',
                '8': '額滿'
            },
            inputValue: jobDemand,
            showCancelButton: true,
            inputValidator: (value) => {
                setDemand(value)
            }
        })
    }

    function setDemand(value) {

        var mRespCustomerPositionInfo = new RespCustomerPositionInfo({})
        mRespCustomerPositionInfo.fromJson(info)
        mRespCustomerPositionInfo.jobDemand = value

        var mRespCustomerPosition = new RespCustomerPositionDetail({
            customerContractId,
            customerPositionId,
            info: JSON.stringify(mRespCustomerPositionInfo),
        })

            console.log(mRespCustomerPositionInfo)
            console.log(mRespCustomerPosition)

        api_addCustomerPosition({
            mRespCustomerPosition,
            success: (jsonData) => {
                Swal.fire({
                    type: 'success',
                    title: '提醒',
                    text: '更新成功',
                }).then(function () {
                    setJobDemand(value)
                })
            },
            failure: (err) => {
                Swal.fire({
                    type: 'error',
                    title: '提醒',
                    text: err,
                })
            }
        })
    }

    const sendMessage = () => {
        if (getWebSocketConnect()) {
            console.log("send")
            //以 emit 送訊息，並以 getMessage 為名稱送給 server 捕捉
            getWebSocketConnect().emit('getMessage', '只回傳給發送訊息的 client')
        }
    }

    function toDetail() {
        var tokenId = uuid(128, 64)
        setVal2Token("customerContractId", customerContractId, tokenId)
        setVal2Token("customerPositionId", customerPositionId, tokenId)
        window.open("/PositionDemandDetail/" + tokenId, "_blank");
    }

    return (
        <tr role="row">
            <td className="text-center">{signAt}</td>
            <td className="text-center">{companyName}&nbsp;</td>
            <td className="text-center">
                <SingleLink link={"PositionDemandDetail" + (isML ? "_ML" : "")}
                    name={jobShiftWage}
                    Key={"positionDemand"}
                    val={{ customerContractId, customerPositionId }} >
                </SingleLink>
            </td>
            {/* <td className="text-center"><a href="#A" onClick={e => toDetail()}>
                {job}
                {item !== undefined ? "/" : <></>}
                {shift}
                {item !== undefined ? "/" : <></>}
                {getItemsInfo({ items: WageType_Arr, val: wageType })}
            </a>&nbsp;</td> */}
            <td className="text-center">
                {workPlace}
                {item !== undefined ? "/" : <></>}
                {workAddress}</td>
            <td className="text-center">
                {isML ?
                    <a href="#A" onClick={e => chooseDemand()}>
                        {getItemsInfo({ items: JobDemand_Arr, val: jobDemand })}
                    </a>
                    : <>{getItemsInfo({ items: JobDemand_Arr, val: jobDemand })}</>
                }
            </td>
            <td className="text-center">
                {item !== undefined ? mItem.companyId !== companyId ? "是" : "否" : <></>}</td>
        </tr>
    )
}
